module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/videos/term-bg-2-264bf96407ecb9c1b1018bf845e0dca0.jpg";